import { ColorModeScript } from "@chakra-ui/react"
import * as React from "react"
import * as ReactDOM from "react-dom/client"
import { App } from "./App"
declare global {
  interface Window {
    DMAZE: any
  }
}
async function waitForConfig() {
  if (window.DMAZE?.appConfig) {
    console.log("WINDOW CONFIG AVAILABLE")
    window.DMAZE.appConfig = {
      ...window.DMAZE.appConfig,
    }
    return
  }

  await new Promise((resolve) => {
    window.requestAnimationFrame(async () => {
      await waitForConfig()
      resolve("config loaded " + window.DMAZE.appConfig)
    })
  })
}

waitForConfig().finally(() => {
  const container = document.getElementById("root")
  if (!container) throw new Error("Failed to find the root element")
  const root = ReactDOM.createRoot(container)

  root.render(
    <React.StrictMode>
      <ColorModeScript initialColorMode="dark" />
      <App />
    </React.StrictMode>
  )
})
